export default "/dist/files/hand_wave.633874d11aad08df046153036d229098.svg";